<template>
  <div class="logo_color_box_1">
    <div class="logo_color_box_2">
      <div class="title_box">
        <img v-if="LogoPath" :src="LogoPath" alt="logo" style="height: 0.7rem;width: 0.7rem;margin-right: 0.3rem;">
        <p>{{ title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderGradRound', // Vue2推荐显式声明组件名
  // 替换Vue3的defineProps，使用Vue2的props选项
  props: {
    title: {
      type: String,
      default: ''
    },
    LogoPath: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* 1. 移除lang="scss"；2. 展开三层SCSS嵌套为普通CSS后代选择器；3. 批量替换--el开头的CSS变量 */
.logo_color_box_1 {
  height: 100%;
  padding: 0 1rem;
  background-color: var(--color-primary-light-3); /* 原--el-color-primary-light-3 → --color-primary-light-3 */
  border-bottom-left-radius: 5rem;
  border-bottom-right-radius: 5rem;
}

.logo_color_box_2 {
  height: 100%;
  padding: 0 1rem;
  background-color: var(--color-primary-dark-2); /* 原--el-color-primary-dark-2 → --color-primary-dark-2 */
  border-bottom-left-radius: 5rem;
  border-bottom-right-radius: 5rem;
}

.title_box {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>